export class Connection {
    environment?: string;
    _id: string;
    id: string;          // the resource id (e.g. /providers/.../connections/<name>) — pulled out so we don't need raw
    name: string;
    apiId: string;
    displayName: string;
    iconUri: string;

    createdTime: Date;
    lastModifiedTime: Date;
    status: string;
    type: string = "connection";
    /**
     * Origin tags — same pattern as `Flow.sources`. A connection seen in both
     * user and admin scope merges to `['user', 'admin']`. Populated by the
     * storage layer on persist; downstream callers can use this to tell apart
     * admin-only resources without a separate field.
     */
    sources: string[] = [];
    /**
     * Light-weight subset of the original payload. We keep the small fields callers
     * need (`id`, `metadata`) on the class itself and DROP everything else from the
     * full API response — connections.properties can be 5–20 KB each (statuses,
     * connectionParameters, OAuth state, testLinks…). On a tenant with thousands of
     * connections that bloat will OOM the renderer. Set raw to null after init.
     */
    raw: any = null;
    private _metadata: any = {};

    connections = [];

    constructor(init?: any){
        if (init) {
            this.initialize(init);
        }
    }

    initialize(item: any) {
        if (item.name) {
            // via api
            this._id = this.name = item.name;
            this.id = item.id || item.name;
            // this.flowName = item.properties.object.flowName;
            this.status = item.properties.status;
            this.createdTime = item.properties.createdTime ? new Date(item.properties.createdTime) : null;
            this.lastModifiedTime = item.properties.lastModifiedTime? new Date(item.properties.lastModifiedTime): null;
            this.apiId = item.properties.apiId;
            this.displayName = item.properties.displayName;
            this.iconUri = item.properties.iconUri;
            this.status = item.properties.statuses.map(a=>a.status).join(', ');
            this._metadata = item.properties.metadata || {};

            this.environment = item.properties.environment.name;

            // Cached rows round-trip the source list through `_sources` (kept
            // off `properties` so it never shows up in upstream API payloads).
            // Live API responses don't carry this — `sources` defaults to [].
            const incoming = (item as any)._sources;
            if (Array.isArray(incoming)) this.sources = incoming.slice();

            // Intentionally do NOT keep this.raw = item — see field comment above.
            return;
        }
    }

    badIconUri() {
        this.iconUri = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';        
    }

    get age(){
        return this.lastModifiedTime ? this.lastModifiedTime.getTime() - this.createdTime.getTime() : null;
    }

    get ageString() {
        var diff = this.age;
        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        diff -=  days * (1000 * 60 * 60 * 24);
        
        var hours = Math.floor(diff / (1000 * 60 * 60));
        diff -= hours * (1000 * 60 * 60);
        
        var mins = Math.floor(diff / (1000 * 60));
        diff -= mins * (1000 * 60);
        
        var seconds = diff/1000;// Math.floor(diff / (1000));
        //diff -= seconds * (1000);

        var results = [];
        if (days) results.push(`${days}d`);
        if (hours) results.push(`${hours}h`);
        if (mins) results.push(`${mins}m`);
        if (seconds) results.push(`${seconds}s`);
        //if (diff) results.push(`${diff}ms`);
        return results.join(' ');
        //document.write(days + " days, " + hours + " hours, " + mins + " minutes, " + seconds + " seconds");        
    }

    get connector() {
        
        var m = /\/apis\/(.*)/gi.exec(this.apiId);
        return m ? m[1] : null;
    }

    hasConnections() {
        return this.connections.length > 0;
    }

    get metadata() {
        return this._metadata || {};
    }

    get actions() : string[] {
        var actions = [];
        //}
        //actions.push('Export Excel');

        actions.push('View Connector JSON');
        actions.push('View Connection JSON');

        return actions;
    }

}

